import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { State, Store } from '@ngrx/store';
import { Payment } from '@uzurv/clara';
import { cloneDeep } from 'lodash';
import { RefundPayment } from '../../../store/organization-rider/organization-rider.actions';
import { OrganizationRiderState } from '../../../store/organization-rider/organization-rider.reducer';

export interface RefundPaymentDialogData {
  payment: Payment;
  organizationRiderId: number;
}

@Component({
  selector: 'app-refund-payment-dialog',
  templateUrl: './refund-payment-dialog.component.html',
  styleUrls: ['./refund-payment-dialog.component.scss']
})
export class RefundPaymentDialogComponent {
  refundPayment: Payment;
  originalPayment: Payment;
  constructor(
    private dialogRef: MatDialogRef<RefundPaymentDialogComponent>,
    private store$: Store<State<OrganizationRiderState>>,
    @Inject(MAT_DIALOG_DATA) private data: RefundPaymentDialogData
  ) {
    this.originalPayment = data.payment;
    this.refundPayment = cloneDeep(data.payment);
    // commenting out since backend doesnt support yet
    // this.refundPayment.paymentDescription = '';
  }

  close() {
    this.dialogRef.close();
  }

  handleRefund(event: any): void {
    this.store$.dispatch(RefundPayment({ payload: { payment: this.refundPayment, dialogRef: this.dialogRef } }));
  }
}
